/*
* @描述:订单售后详情
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/18 10:21
*/
<template>
    <van-popup v-if="dialogVisible"
               v-model.sync="dialogVisible"
               :style="{ width: '100%',height: '100%' }">
        <div class="public_container">
            <div class="returnNavBar">
                <ReturnNavBar :isAllFunctions="false"
                              :isCustomReturnEvent="true"
                              :isTitleNormal="true"
                              :title="type_name"
                              @returnEvent="handleDialogClose">
                </ReturnNavBar>
            </div>
            <div class="after_sale_detail_content">
                <afterSaleApproveDetail :after_sales_type="type" :form_detail="after_sale_detail"/>
            </div>
        </div>
    </van-popup>
</template>
<script>
    import afterSaleApproveDetail from "@/components/mComponents/afterSaleApproveDetail";
    import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";

    export default {
        name: "OrderAfterSaleDetail",
        data() {
            return {}
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false,
            },
            type: {
                type: String,
                default: '',
            },
            type_name: {
                type: String,
                default: '',
            },
            after_sale_detail: {
                type: [Object,Array],
                default: () => {
                    return {};
                },
            },
        },
        components: {
            ReturnNavBar,
            afterSaleApproveDetail
        },
        created() {

        },
        mounted() {
        },
        methods: {
            // 关闭弹窗
            handleDialogClose() {
                this.$emit('update:dialogVisible', false)
            },
        },
    }
</script>
<style lang="scss" scoped>
    .after_sale_detail_content {
        margin-top: 10px;
        height: calc(100% - 54px);
        overflow-y: auto;
        padding: 12px 16px;
        background-color: #FFFFFF;
    }
</style>